// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const ConfirmIn = zod.object({
  "confirm": zod.boolean()
});

export type ConfirmIn = zod.input<typeof ConfirmIn>;
export type ConfirmInOutput = zod.output<typeof ConfirmIn>;
